import { create } from 'zustand';

/**
 * Signal « le contenu cloné des packs a changé de branche ».
 *
 * <p>Il n'y a plus de bascule GLOBALE : chaque groupe choisit sa branche depuis la page Pack, et
 * tout le monde travaille sur develop par défaut. Mais un changement de branche réécrit les fichiers
 * sur disque, donc les écrans qui listent du contenu (catalogues Blocks/Items, page Pack) doivent
 * refetcher. Ce compteur est le point de rendez-vous : celui qui bascule appelle {@link bump}, les
 * écrans qui affichent du contenu observent `version`.</p>
 */
interface PacksBranchState {
  version: number;
  bump: () => void;
}

export const usePacksBranchStore = create<PacksBranchState>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));
